import * as React from 'react';

import ContentPlaceholder from 'basics/loaders/ContentPlaceholder/ContentPlaceholder';

import { PageContainer } from 'styles/commonPageStyles';
import { COLORS } from 'styles/style-constants';

import { Wrapper } from './SwapPage.styled';

import SwapFormLoading from '../components/SwapForm/SwapFormLoading';

const SwapPageLoading = () => (
    <PageContainer $color={COLORS.gray50} $mobileColor={COLORS.white}>
        <Wrapper>
            <ContentPlaceholder label="Loading swap">
                <SwapFormLoading />
            </ContentPlaceholder>
        </Wrapper>
    </PageContainer>
);

export default SwapPageLoading;
